var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('div',{},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":_vm.gotoAddDriver}},[_vm._v("\n      Add Driver\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"drivers"},_vm._l((_vm.drivers),function(item,index){return _c('Details',{key:index,attrs:{"driver":item}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8e2ee7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/admin/driver/Drivers.html
// module id = null
// module chunks = 